import moment from 'moment'
import { TODAY } from 'constants/managementUI'

export const getUniqueTasksAssignees = job => {
  const assigned_users = []
  const assigned_user_groups = []

  job.tasks.forEach(
    ({ assigned_users: taskUsers, assigned_user_groups: taskGroups }) => {
      taskUsers.forEach(item => {
        assigned_users.push(item)
      })
      taskGroups.forEach(item => {
        assigned_user_groups.push(item)
      })
    },
  )

  const uniqueUsers = [
    ...new Map(assigned_users.map(item => [item.id, item])).values(),
  ]
  const uniqueGroups = [
    ...new Map(assigned_user_groups.map(item => [item.id, item])).values(),
  ]

  return {
    assigned_users: uniqueUsers,
    assigned_user_groups: uniqueGroups,
  }
}

export const getMUIIsToday = (jobsManagementFilters, date) => {
  const {
    date: appliedDateFilter,
    date_range_from: appliedDateRangeFromFilter,
    date_range_to: appliedDateRangeToFilter,
  } = jobsManagementFilters

  return (
    appliedDateFilter === TODAY ||
    (appliedDateFilter === null &&
      appliedDateRangeFromFilter === null &&
      appliedDateRangeToFilter === null) ||
    (date &&
      moment(date) >= moment(appliedDateRangeFromFilter) &&
      moment(date) <= moment(appliedDateRangeToFilter) &&
      date === moment().format('YYYY-MM-DD'))
  )
}
